import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { RouterLink } from '@angular/router';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-contratacao-rota-inteligente',
    templateUrl: './contratacao-rota-inteligente.component.html',
    styleUrls: ['./contratacao-rota-inteligente.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, BreadcrumbComponent, RouterLink, FooterComponent]
})
export class ContratacaoRotaInteligenteComponent {

  public loadingGenerico: boolean = false;
}
